exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-Button--secondary {\n  background-color: #ea0100; }\n  .hover-active .a-Button--secondary:hover,\n  .hover-active .a-Button--secondary:focus {\n    background-color: #b70100; }\n", ""]);

// exports
